<div>
  <p class="recordsummary" *ngIf="pmViewData.length">{{ pmHeaderMessage }}</p>
</div>

<!-- Start - Main Grid Section -->
<div class="ButtonList">
  <div class="ButtonLeft">
    <button
      [ngClass]="
        headerSelectedIds.size == 0 ? 'btn-disabled' : 'button-primary'
      "
      (click)="deleteSelected()"
    >
      Delete Selected
    </button>
    <button
      [ngClass]="
        headerSelectedIds.size == 0 ? 'btn-disabled' : 'button-secondary'
      "
      (click)="undoSelected()"
    >
      Undelete Selected
    </button>
  </div>
  <div class="ButtonRight">
    <button class="button-primary" (click)="clearPM(true)">Clear All</button>
    <button
      class="button-secondary"
      (click)="clearPM(false)"
      [ngClass]="
        headerSelectedIds.size == 0 ? 'btn-disabled' : 'button-secondary'
      "
    >
      Clear Selected
    </button>
    <button
      id="exportPMBuild"
      class="button-secondary"
      (click)="clickExport('Header')"
    >
      Export
    </button>
    <button class="button-secondary" (click)="clickImport('Header')">
      Import
    </button>
  </div>
</div>
<div id="pmnonStyleGrid" [ngStyle]="pmViewData.length > 5 ? { 'max-height': '50vh', 'overflow-y': 'auto' } : {}">
  <kendo-grid
    [data]="pmViewData"
    
   class='buildGrid'
    [selectable]="{ enabled: true, checkboxOnly: true }"
    (selectionChange)="OnSelectionChangeEventGrid($event, 'mainGrid')"
  >
    <kendo-grid-checkbox-column
      [width]="45"
      [headerClass]="{ 'text-center': true }"
      [class]="{ 'text-center': true }"
      [resizable]="false"
      [columnMenu]="true"
      id="my-grid"
      [columnMenu]="false"
      [showSelectAll]="true"
      class="customgrid"
    ></kendo-grid-checkbox-column>
    <kendo-grid-column title="" [width]="60">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="iconList">
          <span
            (click)="addNewPM()"
            *ngIf="dataItem.acdAction === 'Add'"
            [class.icon-disabled2]="!isUserHaveAccess"
          >
            <fa-icon
              [icon]="iconPacks.FASQUAREPLUS"
              class="bluePrimary pmBtnSize plusIcon"
              [ngClass]="isUserHaveAccess ? '' : 'icon-disabled2'"
            >
            </fa-icon>
          </span>

          <span
            (click)="
              deletePMbyId(
                dataItem.changeItemId,
                dataItem.acdAction,
                dataItem.id
              )
            "
            [ngClass]="{ 'ml-5': dataItem.acdAction === 'Add' }"
            [class.icon-disabled2]="!isUserHaveAccess"
            *ngIf="
              dataItem.acdAction === 'Add' || dataItem.acdAction === 'Change'
            "
          >
            <fa-icon
              [icon]="iconPacks.FAMINUSSQUARE"
              class="bluePrimary pmBtnSize plusIcon"
              [ngClass]="isUserHaveAccess ? '' : 'icon-disabled2'"
            >
            </fa-icon>
          </span>

          <span
            [ngClass]="{
              'ml-5': dataItem.acdAction === 'Change'
            }"
            *ngIf="
              dataItem.acdAction === 'Change' || dataItem.acdAction === 'Delete'
            "
            (click)="undoHeaderById(dataItem.changeItemId)"
            [class.icon-disabled2]="!isUserHaveAccess"
          >
            <fa-icon
              [icon]="iconPacks.FACIRCLE"
              class="bluePrimary pmBtnSize searchIcon"
              [ngClass]="isUserHaveAccess ? '' : 'icon-disabled2'"
            >
            </fa-icon>
          </span>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column  [width]="70">
      <ng-template kendoGridHeaderTemplate><div class="wrapped-header">ACD Action</div></ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-label>{{ dataItem.acdAction }}</kendo-label>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="" [width]="50">
      <ng-template kendoGridCellTemplate let-dataItem>
        <fa-icon
          [icon]="iconPacks.FASTAR"
          class="plusIcon"
          *ngIf="!dataItem.isAddedToCR"
        ></fa-icon>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="equipTagNumber"
      title="Equip Tag Number"
      [width]="150"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
          {{ dataItem.equipTagNumber }}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="serviceType" title="Service Type" [width]="170">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngIf="dataItem.acdAction == 'Add'">
          <kendo-textbox
            [maxlength]="8"             
            [(ngModel)]="dataItem.serviceType"
            style="width: 80%"
            #equipTagNumberTextBox
            id="{{ dataItem.changeItemId + '_serviceType' }}"
            (valueChange)="onHeaderValueChange(dataItem, 'serviceType', $event)"
            [ngClass]="{
              backgroundChange:
                dataItem.acdAction === 'Add' ||
                dataItem.fieldChangedList?.includes('serviceType'),
              'field-mandatory': dataItem.errorList?.includes('ServiceType')
            }"
          >
          </kendo-textbox>
          <span #equipTagNumber *ngIf="dataItem.acdAction == 'Add'">
            <fa-icon
              [icon]="iconPacks.FASEARCH"
              [style]="'margin-left: 15px;'"
              [ngClass]="isUserHaveAccess ? '' : 'icon-disabled2'"
              class="bluePrimary searchIcon"
              (click)="openActionPopup('serviceType', dataItem)"
            ></fa-icon>
          </span>
        </div>
        <div [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
             *ngIf="dataItem.acdAction !== 'Add'">
          {{ dataItem.serviceType | slice:0:8 }}
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="mwoNumber" title="MWO" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngIf="dataItem.acdAction === 'Add'">
          <kendo-textbox
            [(ngModel)]="dataItem.mwoNumber"
            style="width: 80%"
            #mwoNumberTextBox
            id="{{ dataItem.changeItemId + '_mwoNumber' }}"
            (valueChange)="onHeaderValueChange(dataItem, 'mwoNumber', $event)"
            [ngClass]="{
              backgroundChange:
                dataItem.acdAction === 'Add' ||
                dataItem.fieldChangedList?.includes('mwoNumber'),
              'field-mandatory': dataItem.errorList?.includes('MWO')
            }"
            (focusout)="mwoNumberChange(dataItem)"
          >
          </kendo-textbox>
          <span #mwoNumber *ngIf="dataItem.acdAction == 'Add'">
            <fa-icon
              [icon]="iconPacks.FASEARCH"
              class="bluePrimary searchIcon ml-5"
              (click)="openActionPopup('mwoNumber', dataItem)"
            ></fa-icon>
          </span>
        </div>
        <div
          [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
          *ngIf="dataItem.acdAction !== 'Add'"
        >
          {{ dataItem.mwoNumber }}
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="mwoProblemDescription"
      title="MWO Problem Description"
      [width]="200"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
          {{ dataItem.mwoProblemDescription }}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="mainStatus"  [width]="70">
      <ng-template kendoGridHeaderTemplate><div class="wrapped-header">Maint Status</div></ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="(dataItem?.mainStatus ?? 0) > 0"
              [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
          {{ dataItem.mainStatus }}
        </span>
        <!-- < 9 ? "0" + dataItem.mainStatus : dataItem.mainStatus -->
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="performanceStandard"
                       [width]="105">
      <ng-template kendoGridHeaderTemplate><div class="wrapped-header">Performance Standard</div></ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
          {{ dataItem.performanceStandard }}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="frequencyIndicator"
      title="Frequency Indicator"
      [width]="150"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngIf="dataItem.acdAction != 'Delete'">
          <kendo-textbox
            [maxlength]="1"
            [(ngModel)]="dataItem.frequencyIndicator"
            id="{{ dataItem.changeItemId + '_frequencyIndicator' }}"
            [disabled]="dataItem.disabledItems"
            (valueChange)="
              onHeaderValueChange(dataItem, 'frequencyIndicator', $event)
            "
            (input)="validateInput('frequencyIndicator', $event)"
            [ngClass]="{
              backgroundChange:
                dataItem.acdAction === 'Add' ||
                dataItem.fieldChangedList?.includes('frequencyIndicator'),
              'field-mandatory':
                dataItem.errorList?.includes('FrequencyIndicator')
            }"
            style="width: 80%"
          >
          </kendo-textbox>
          <span #frequencyIndicator>
            <fa-icon
              [icon]="iconPacks.FASEARCH"
              class="bluePrimary searchIcon ml-5"
              (click)="openActionPopup('frequencyIndicator', dataItem)"
              [class.icon-disabled2]="!isUserHaveAccess"
            ></fa-icon>
          </span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="schedTickler" title="Schedule Date" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngIf="dataItem.acdAction != 'Delete'">
          <kendo-textbox
          placeholder="DD/MM/YYYY"
    type="text"
    class="k-input k-textbox k-input-md k-rounded-md k-input-solid"
    [(ngModel)]="dataItem.schedTicklerEntered"
    style="width: 70%"
    [disabled]="dataItem.serviceType === 'UNSCHD01'"
    [ngClass]="
      (dataItem.acdAction === 'Add' &&
      dataItem.errorList?.includes('SchedTickler')) || (dataItem.acdAction != 'Add' && dataItem.fieldChangedList?.includes('schedTickler') && dataItem.errorList?.includes('SchedTickler'))
        ? 'backgroundChange field-mandatory'
        : dataItem.acdAction === 'Add' ||
          dataItem.fieldChangedList?.includes('schedTickler')
        ? 'backgroundChange'
        : dataItem.errorList?.includes('SchedTickler')
        ? 'field-mandatory'
        : ''
    "
    (valueChange)="
      onHeaderValueChange(dataItem, 'schedTicklerEntered', $event, true,true,'schedTickler')
    "

                [disabled]="dataItem.disabledItems"
          ></kendo-textbox>
          <span [class.icon-disabled2]="dataItem.disabledItems">
          <fa-icon
            [icon]="iconPacks.FACALENDAR"
                     style="margin-left: 10px"
            (click)="toggleDatepicker(datepickerEnd)"
          ></fa-icon>
          </span>
          <kendo-datepicker
            style="visibility: hidden; width: 15%"
                            #datepickerEnd
                            [(ngModel)]="dataItem.schedTickler"
                            class="k-datepicker k-input-md k-rounded-md k-input-solid"
                            [popupSettings]="{}"
                            [calendarType]="'classic'"
                            [format]="'dd/MM/yyyy'"
                            (valueChange)="
              onHeaderValueChange(
                dataItem,
                'schedTicklerSelected',
                $event,
                true
              )
            "
          >
          </kendo-datepicker>
        </div>
        <span *ngIf="dataItem.acdAction == 'Delete'" class="strike-text">
          {{ dataItem.schedTickler | date : "dd-MM-yyyy" }}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="maintenanceCoordinatorCode"
      title="Area Owner Code"
      [width]="150"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <kendo-numerictextbox
          format="##"
          [step]="1"
          [min]="1"
          [(ngModel)]="dataItem.maintenanceCoordinatorCode"
          id="{{ dataItem.changeItemId + '_maintenanceCoordinatorCode' }}"
          (valueChange)="
            onHeaderValueChange(dataItem, 'maintenanceCoordinatorCode', $event)
          "
          [ngClass]="{
            backgroundChange:
              dataItem.acdAction === 'Add' ||
              dataItem.fieldChangedList?.includes('maintenanceCoordinatorCode'),
            'field-mandatory': dataItem.errorList?.includes(
              'MaintenanceCoordinatorCode'
            )
          }"
          [spinners]="false"
          *ngIf="dataItem.acdAction != 'Delete'"
        >
        </kendo-numerictextbox>
        <span *ngIf="dataItem.acdAction == 'Delete'" class="strike-text">
          {{ dataItem.maintenanceCoordinatorCode }}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="planningCoordinatorCode"
                       [width]="170">
      <ng-template kendoGridHeaderTemplate><div class="wrapped-header">Assigned Exec Coord Code</div></ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <kendo-numerictextbox format="##"
                              [step]="1"
                              [min]="1"
                              [(ngModel)]="dataItem.planningCoordinatorCode"
                              id="{{ dataItem.changeItemId + '_planningCoordinatorCode' }}"
                              [ngClass]="{
            backgroundChange:
              dataItem.acdAction === 'Add' ||
              dataItem.fieldChangedList?.includes('planningCoordinatorCode'),
            'field-mandatory': dataItem.errorList?.includes(
              'PlanningCoordinatorCode'
            )
          }"
                              [spinners]="false"
                              *ngIf="dataItem.acdAction != 'Delete'"
                              (valueChange)="
            onHeaderValueChange(dataItem, 'planningCoordinatorCode', $event)
          "></kendo-numerictextbox>
        <span *ngIf="dataItem.acdAction == 'Delete'" class="strike-text">
          {{ dataItem.planningCoordinatorCode }}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="serviceDays" title="Service Days" [width]="150">
      <ng-template
        kendoGridCellTemplate
        let-dataItem
        let-rowIndex="rowIndex"
        let-columnIndex="columnIndex"
      >
        <kendo-numerictextbox
          [disabled]="dataItem.disabledItems"
          format="##"
          [step]="1"
          [min]="1"
          [(ngModel)]="dataItem.serviceDays"
          id="{{ dataItem.changeItemId + '_serviceDays' }}"
          (valueChange)="onHeaderValueChange(dataItem, 'serviceDays', $event)"
          [ngClass]="{
            backgroundChange:
              dataItem.acdAction === 'Add' ||
              dataItem.fieldChangedList?.includes('serviceDays'),
            'field-mandatory': dataItem.errorList?.includes('ServiceDays')
          }"
          [spinners]="false"
          *ngIf="dataItem.acdAction != 'Delete'"
        ></kendo-numerictextbox>
        <span *ngIf="dataItem.acdAction == 'Delete'" class="strike-text">
          {{ dataItem.serviceDays }}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="lastCompDate"
      title="Last Comp Date"
      [width]="150"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngIf="dataItem.acdAction != 'Delete'">
          <kendo-textbox
            placeholder="DD/MM/YYYY"
            type="text"
            class="k-input k-textbox k-input-md k-rounded-md k-input-solid"
            [(ngModel)]="dataItem.lastCompDateEntered"
            style="width: 70%"
                                    [disabled]="dataItem.disabledItems"

            [ngClass]="
              dataItem.acdAction === 'Add' &&
              dataItem.errorList?.includes('LastCompDate') || (dataItem.acdAction != 'Add' && dataItem.fieldChangedList?.includes('lastCompDate') && dataItem.errorList?.includes('LastCompDate'))
                ? 'backgroundChange field-mandatory'
                : dataItem.acdAction === 'Add' ||
                  dataItem.fieldChangedList?.includes('lastCompDate')
                ? 'backgroundChange'
                : dataItem.errorList?.includes('LastCompDate')
                ? 'field-mandatory'
                : ''
            "
            (valueChange)="
              onHeaderValueChange(dataItem, 'lastCompDateEntered', $event, true,true,'lastCompDate')
            "
          ></kendo-textbox>
          <span #lastCompDate [class.icon-disabled2]="dataItem.disabledItems">
          <fa-icon
            [icon]="iconPacks.FACALENDAR"
            style="margin-left: 10px"
            (click)="toggleDatepicker(datepickerEnd)"
          ></fa-icon>
          </span>
          <kendo-datepicker
            style="visibility: hidden; width: 15%"
            #datepickerEnd
            [(ngModel)]="dataItem.lastCompDate"
            class="k-datepicker k-input-md k-rounded-md k-input-solid"
            [popupSettings]="{}"
            [calendarType]="'classic'"
            [format]="'dd/MM/yyyy'"
            [disabled]="dataItem.serviceType === 'UNSCHD01'"
            (valueChange)="
              onHeaderValueChange(
                dataItem,
                'lastCompDateSelected',
                $event,
                true
              )
            "
          >
          </kendo-datepicker>
        </div>
        <span *ngIf="dataItem.acdAction == 'Delete'" class="strike-text">
          {{ dataItem.lastCompDate | date : "dd-MM-yyyy" }}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="multiFlag" title="Multi Flag" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-dropdownlist
          [disabled]="dataItem.disabledItems"
          defaultItem=""
          [data]="multiFlagOptions"
          [(ngModel)]="dataItem.multiFlag"
          *ngIf="dataItem.acdAction != 'Delete'"
          (valueChange)="
            onHeaderValueChange(dataItem, 'multiFlag', dataItem.multiFlag)
          "
          [ngClass]="{
            backgroundChange:
              dataItem.acdAction === 'Add' ||
              dataItem.fieldChangedList?.includes('multiFlag'),
            'field-mandatory': dataItem.errorList?.includes('MultiFlag')
          }"
        >
        </kendo-dropdownlist>
        <span *ngIf="dataItem.acdAction == 'Delete'" class="strike-text">
          {{ dataItem.multiFlag }}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="occurrence" title="Occurrence" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
          {{ dataItem.occurrence }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoGridNoRecordsTemplate>
      <div class="norecordsmwobuild">No items to show...</div>
    </ng-template>
  </kendo-grid>

  <div class="errorCount">
    <app-grid-mwo-error
      *ngIf="mwoErrorTextList.length > 0"
      [setGridData]="mwoErrorTextList"
    ></app-grid-mwo-error>
    <span class="workOrderCOunt"
      >{{ pmViewData.length }} PM Schedule<span *ngIf="pmViewData.length > 1"
        >s</span
      ></span
    >
  </div>
</div>
<!-- End - Main Grid Section -->

<!-- Start - Equipment Route Section -->
<div class="margin-15">
  <kendo-expansionpanel
    title="Equipment Routes"
    class="expansion"
    [expanded]="true"
    (click)="expandCollapseContent()"
  >
    <div class="expBtnList">
      <div>
        <kendo-dropdownlist
          [data]="dropDownList"
          class="changeDropdown"
          [(ngModel)]="equipmentRouteActionName"
          [fillMode]="'flat'"
        >
        </kendo-dropdownlist>
        <button
          [ngClass]="
            equipmentSelectedIds.size == 0 ? 'btn-disabled' : 'button-secondary'
          "
          (click)="equipmentRouteActionApply()"
        >
          Apply action for Selected
        </button>

        <button
          class="button-secondary"
          *ngIf="actionApplied"
          (click)="undoActionApplied()"
        >
          Undo
        </button>
      </div>
      <div>
        <button
          class="button-secondary_Export"
          id="exportPMBuild"
          (click)="clickExport('EquipmentRoute')"
        >
          Export
        </button>
        <button
          class="button-secondary_Import"
          (click)="clickImport('EquipmentRoute')"
        >
          Import
        </button>
      </div>
    </div>
    <div id="nonStyleGrid">
      <kendo-grid
        [rowClass]="rowCallback" 
        class="kendoMwoGrid buildGrid"
        [data]="equipmentRouteViewData_Filtered"
        [selectable]="{ enabled: true, checkboxOnly: true }"
        (selectionChange)="OnSelectionChangeEventGrid($event, 'equipment')"
      >
        <kendo-grid-checkbox-column
          [width]="45"
          [headerClass]="{ 'text-center': true }"
          [class]="{ 'text-center': true }"
          [resizable]="false"
          [columnMenu]="true"
          id="my-grid"
          [columnMenu]="false"
          [showSelectAll]="true"
          class="customgrid"
        ></kendo-grid-checkbox-column>
        <kendo-grid-column title="" [width]="50">
          <ng-template
            kendoGridCellTemplate
            let-dataItem
            let-rowIndex="rowIndex"
          >
            <span
              (click)="addEquipmentRoute(dataItem, rowIndex)"
              [class.icon-disabled2]="!isUserHaveAccess"
            >
              <fa-icon
                [icon]="iconPacks.FASQUAREPLUS"
                [ngClass]="isUserHaveAccess ? '' : 'icon-disabled2'"
                class="bluePrimary pmBtnSize plusIcon"
              >
              </fa-icon>
            </span>

            <span
              (click)="deleteEquipmentRoute(dataItem, rowIndex)"
              *ngIf="dataItem.acdAction !== 'Delete'"
              [class.icon-disabled2]="!isUserHaveAccess"
              class="ml-5"
              ><fa-icon
                [icon]="iconPacks.FAMINUSSQUARE"
                class="bluePrimary pmBtnSize plusIcon"
                [ngClass]="isUserHaveAccess ? '' : 'icon-disabled2'"
              >
              </fa-icon>
            </span>

            <span
              (click)="undoEquipmentRoute(dataItem, rowIndex)"
              *ngIf="dataItem.acdAction === 'Delete'"
              [class.icon-disabled2]="!isUserHaveAccess"
              class="ml-5"
              ><fa-icon
                [icon]="iconPacks.FACIRCLE"
                class="bluePrimary pmBtnSize plusIcon"
                [ngClass]="isUserHaveAccess ? '' : 'icon-disabled2'"
              >
              </fa-icon>
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="acdAction" title="Action" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
              {{ dataItem.acdAction }}
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="headerTag" title="Header Tag" [width]="150">
          <ng-template kendoGridHeaderTemplate>
            Header Tag
            <span (click)="headerRouteTagSearchPopUpOpen('Header')">
              <fa-icon
                [icon]="iconPacks.FASEARCHPLUS"
                class="ml-5 font-10 bluePrimary plusIcon"
              >
              </fa-icon>
            </span>

            <span
              (click)="clearHeaderRouteTagFilter('Header')"
              *ngIf="headerTagSearchText.size > 0"
            >
              <fa-icon
                [icon]="iconPacks.FACLOSE"
                class="ml-5 font-10 bluePrimary plusIcon"
              >
              </fa-icon>
            </span>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
              {{ dataItem.headerTag }}
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="routeTag" title="Route Tag" [width]="150">
          <ng-template kendoGridHeaderTemplate>
            Route Tag
            <span (click)="headerRouteTagSearchPopUpOpen('Route')">
              <fa-icon
                [icon]="iconPacks.FASEARCHPLUS"
                class="ml-5 font-10 bluePrimary plusIcon"
              >
              </fa-icon>
            </span>

            <span
              (click)="clearHeaderRouteTagFilter('Route')"
              *ngIf="routeTagSearchText.size > 0"
            >
              <fa-icon
                [icon]="iconPacks.FACLOSE"
                class="ml-5 font-10 bluePrimary plusIcon"
              >
              </fa-icon>
            </span>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            <div *ngIf="dataItem.acdAction == 'Add'">
              <kendo-textbox
                [(ngModel)]="dataItem.routeTag"
                style="width: 80%"
                #routeTagTextBox
                id="{{ dataItem.changeItemId + '_routeTag' }}"
                (valueChange)="
                  onEquipmentRouteValueChange(dataItem, 'routeTag', $event)
                "
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    dataItem.fieldChangedList?.includes('routeTag'),
                  'field-mandatory': dataItem.errorList?.includes('RouteTag')
                }"
              >
              </kendo-textbox>
              <span #routeTag>
                <fa-icon
                  [icon]="iconPacks.FASEARCH"
                  [style]="'margin-left: 15px;'"
                  class="bluePrimary searchIcon"
                  (click)="openActionPopup('equipTagNumber', dataItem)"
                  [class.icon-disabled2]="!isUserHaveAccess"
                ></fa-icon>
              </span>
            </div>
            <span
              [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              *ngIf="dataItem.acdAction != 'Add'"
            >
              {{ dataItem.routeTag }}
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          field="headerRoute"
          title="Header Route"
          [width]="120"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <div *ngIf="dataItem.acdAction != 'Delete'">
              <kendo-dropdownlist
                [data]="HeaderDropdown"
                [(ngModel)]="dataItem.headerRoute"
                (valueChange)="
                  onEquipmentRouteValueChange(dataItem, 'headerRoute', $event)
                "
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    dataItem.fieldChangedList?.includes('headerRoute'),
                  'field-mandatory': dataItem.errorList?.includes('HeaderRoute')
                }"
                >>
              </kendo-dropdownlist>
            </div>
            <span
              [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              *ngIf="dataItem.acdAction == 'Delete'"
              >{{ dataItem.headerRoute }}</span
            >
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          field="serviceType"
          title="Service Type"
          [width]="100"    
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
              {{ dataItem.serviceType }}
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="mwo" title="MWO" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
              {{ dataItem.mwo }}
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          field="performanceStandard"
          title="Perf Std"
          [width]="100"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
              {{ dataItem.performanceStandard }}
            </span>
          </ng-template>
        </kendo-grid-column>
        <ng-template kendoGridNoRecordsTemplate>
          <div class="norecordsmwobuild">No items to show...</div>
        </ng-template>
      </kendo-grid>
    </div>
    <span class="totalCount"
      >{{ equipmentRouteViewData_Filtered.length }} Routes</span
    >
  </kendo-expansionpanel>
</div>
<!-- End - Equipment Route Section -->
<div class="margin-15">
  <kendo-expansionpanel
    title="Associations"
    class="expansion"
    [expanded]="true"
    (click)="expandCollapseContent()"
  >
    <!-- <ng-template kendoExpansionPanelTitleDirective>
            <span class="expansiontitle">Associations</span><span class="expansionSubTitle">{{
                associationViewData.length }} records saved</span>
        </ng-template> -->
    <div>
      <div class="addRow">
        <button
          class="button-secondary_Import"
          (click)="addAssociation()"
          [ngClass]="{ 'btn-disabled': headerSelectedIds.size == 0 }"
        >
          Add Row
        </button>
      </div>
      <div id="nonStyleGrid">
        <kendo-grid
          [data]="associationViewData_Filtered"
          
         class='buildGrid'
          [selectable]="{ enabled: true, checkboxOnly: true }"
          (selectionChange)="OnSelectionChangeEventGrid($event, 'association')"
        >
          <kendo-grid-checkbox-column
            [width]="45"
            [headerClass]="{ 'text-center': true }"
            [class]="{ 'text-center': true }"
            [resizable]="false"
            [columnMenu]="true"
            id="my-grid"
            [columnMenu]="false"
            [showSelectAll]="true"
            class="customgrid"
          ></kendo-grid-checkbox-column>
          <kendo-grid-column field="mwo" title="" [width]="60">
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <span
                (click)="addAssociationRow(dataItem, rowIndex)"
                [class.icon-disabled2]="!isUserHaveAccess"
              >
                <fa-icon
                  [icon]="iconPacks.FASQUAREPLUS"
                  [ngClass]="isUserHaveAccess ? '' : 'icon-disabled2'"
                  class="bluePrimary pmBtnSize plusIcon"
                >
                </fa-icon>
              </span>
              <span
                class="ml-5"
                *ngIf="
                  dataItem.acdAction === 'No change' ||
                  dataItem.acdAction === 'Add'
                "
                (click)="deleteAssociationRow(dataItem, rowIndex)"
                [class.icon-disabled2]="!isUserHaveAccess"
              >
                <fa-icon
                  [icon]="iconPacks.FAMINUSSQUARE"
                  [ngClass]="isUserHaveAccess ? '' : 'icon-disabled2'"
                  class="bluePrimary pmBtnSize plusIcon"
                >
                </fa-icon>
              </span>
              <span
                class="ml-5"
                *ngIf="dataItem.acdAction === 'Delete'"
                (click)="undoAssociationRow(dataItem, rowIndex)"
                [class.icon-disabled2]="!isUserHaveAccess"
              >
                <fa-icon
                  [icon]="iconPacks.FACIRCLE"
                  class="bluePrimary pmBtnSize searchIcon"
                  [ngClass]="isUserHaveAccess ? '' : 'icon-disabled2'"
                >
                </fa-icon>
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="acdAction" title="ACD Action" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.acdAction }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="equipTagNumber"
            title="Equip Tag Number"
            [width]="150"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.equipTagNumber }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="mwo" title="MWO" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.mwo }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="serviceDays"
            title="Service Days"
            [width]="100"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.serviceDays }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="majorServiceType"
            title="Major Service Type"
            [width]="150"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.majorServiceType }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="minorServiceType"
            title="Minor Service Type"
            [width]="200"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <div *ngIf="dataItem.acdAction == 'Add'">
                <kendo-textbox
                  [(ngModel)]="dataItem.serviceType"
                  style="width: 80%"
                  [maxlength]="8"
                  #minorServiceTypeTextBox
                  id="{{ dataItem.changeItemId + '_minorServiceType' }}"
                  (valueChange)="
                    onAssociationValueChange(
                      dataItem,
                      'minorServiceType',
                      $event
                    )
                  "
                  [ngClass]="{
                    backgroundChange:
                      dataItem.acdAction === 'Add' ||
                      dataItem.fieldChangedList?.includes('minorServiceType'),
                    'field-mandatory':
                      dataItem.errorList?.includes('ServiceType')
                  }"
                >
                </kendo-textbox>
                <span #minorServiceType>
                  <fa-icon
                    [icon]="iconPacks.FASEARCH"
                    [style]="'margin-left: 15px;'"
                    class="bluePrimary searchIcon"
                    (click)="openActionPopup('minorServiceType', dataItem)"
                    [class.icon-disabled2]="!isUserHaveAccess"
                  ></fa-icon>
                </span>
              </div>
              <span *ngIf="dataItem.acdAction != 'Add'"
                    [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
                {{ dataItem.serviceType | slice:0:8 }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="supPression"
            title="Suppression"
            [width]="120"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <div *ngIf="dataItem.acdAction == 'Add'">
                <kendo-dropdownlist
                  [data]="suppressedDropdown"
                  [(ngModel)]="dataItem.supPression"
                  (valueChange)="
                    onAssociationValueChange(dataItem, 'supPression', $event)
                  "
                  [ngClass]="{
                    backgroundChange:
                      dataItem.acdAction === 'Add' ||
                      dataItem.fieldChangedList?.includes('supPression'),
                    'field-mandatory':
                      dataItem.errorList?.includes('SupPression')
                  }"
                >
                  >
                </kendo-dropdownlist>
              </div>
              <span
                *ngIf="dataItem.acdAction != 'Add'"
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
                >{{ dataItem.supPression }}</span
              >
            </ng-template>
          </kendo-grid-column>
          <ng-template kendoGridNoRecordsTemplate>
            <div class="norecordsmwobuild">No items to show...</div>
          </ng-template>
        </kendo-grid>
      </div>
      <span class="totalCount"
        >{{ associationViewData_Filtered.length }} Association
        <span *ngIf="associationViewData_Filtered.length > 1">s</span></span
      >
    </div>
  </kendo-expansionpanel>
</div>

<div class="bottomButtons">
  <button
    class="button-back"
    id="backStepNavigation"
    (click)="backBTNClicked()"
  >
    <a class="backLink">Back</a>
  </button>
  <button class="button-secondary btn2" (click)="saveAndAddToCr()">
    Save and Add to CR
  </button>
</div>

<app-content-popup
  *ngIf="popupShow"
  [dialogTitle]="popupTitle"
  [width]="popupWidth"
  [height]="popupHeight"
  (closeContentPopUp)="closeActionPopup($event)"  
>
  <ng-container>
      <app-select-item-popup
        [setColumnConfig]="popupGridColumn"
        [setPlaceholder]="searchPlaceHolder"
        [setGridData]="popupDataList"
        [setIsPopUpHasSearch]="isPopUpHasSearch"
        (sendDataItem)="dataItemSelcted($event)"
        (pageChanged)="popupPageChanged($event)"
        [buttonText]="searchButton"
        ></app-select-item-popup>
  </ng-container>
</app-content-popup>

<app-content-popup
  *ngIf="showFileUploadPopup"
  [dialogTitle]="popupTitle"
  [width]="popupWidth"
  [height]="popupHeight"
  (closeContentPopUp)="closeActionPopup($event)"
>
  <ng-container>
    <app-build-import
      [setFieldValidationInput]="fieldValidationInput"
      (contentValidated)="imported($event)"
    ></app-build-import>
  </ng-container>
</app-content-popup>

<app-content-popup
  *ngIf="headerRouteTagSearchPopUpOpened"
  [dialogTitle]="headerRouteTagSearchPopUpTitle"
  [width]="600"
  [height]="400"
  (closeContentPopUp)="headerRouteTagSearch()"
>
  <ng-container>
    <div class="mt-10">
      <div>
        <kendo-textarea
          class="popuptextBox"
          [(ngModel)]="headerRouteTagSearchText"
          [maxlength]="3500"
          [rows]="10"
          placeholder="Paste text here.. (One entry per line )"
        ></kendo-textarea>
      </div>
      <div class="popupFunctions">
        <kendo-label class="characterCount"
          >Characters left : {{ 3500 - headerRouteTagSearchText.length }}
          <span *ngIf="headerRouteTagSearchText.length == 3500">
            reached limit</span
          >
        </kendo-label>
        <button
          type="submit"
          class="primarybtn"
          (click)="headerRouteTagSearch()"
        >
          Submit
        </button>
      </div>
    </div>
  </ng-container>
</app-content-popup>
